module.exports = __webpack_public_path__ + "media/אב.ff8d0118.mp3";